module.exports = __webpack_public_path__ + "img/BellIcon.272c5a50.svg";